import React from 'react';
import Styles from './module-detail-student-styles.scss';
import HeaderModules from '../my-modules/components/header-modules/header-modules';
import ModuleDescription from './components/module-description/module-description';
import Lesson from './components/lesson/lesson';
import { BulbIcon, CircleLoader, ProgressBar } from '@/presentation/components';
import LessonsGrid from './components/lessons-grid/lessons-grid';
import { useNavigate, useParams } from 'react-router';
import Skeleton from 'react-loading-skeleton';
import useModuleDetailStudent from '@/presentation/hooks/use-module-detail-student';
const ModuleDetailStudent = ({ loadKeywords, loadLessons, loadModules, loadPrequiz, loadProgress, loadQuizUsers, manageProgress }) => {
    const { keywords, loading, moduleData, currentUserSession, idModule, lessons, preQuiz, studentProgressInModulePercent, studentScoreInModulePercent, prequizUser } = useModuleDetailStudent({
        loadKeywords,
        loadLessons,
        loadModules,
        loadPrequiz,
        loadProgress,
        loadQuizUsers,
        manageProgress
    });
    const subscription = currentUserSession === null || currentUserSession === void 0 ? void 0 : currentUserSession.subscription;
    const isTrial = (subscription === null || subscription === void 0 ? void 0 : subscription.status) === 'trialing';
    const navigate = useNavigate();
    const { idStudent } = useParams();
    const id = idStudent;
    let idPrequiz = 0;
    if (preQuiz === null || preQuiz === void 0 ? void 0 : preQuiz.id) {
        idPrequiz = preQuiz === null || preQuiz === void 0 ? void 0 : preQuiz.id;
    }
    return (React.createElement("div", { className: Styles.moduleDetailWrap },
        React.createElement(HeaderModules, { back: true, scoreMarkerText: "Module avg. score:", percentage: studentScoreInModulePercent, scoreMarkerBackground: "purple", onBack: () => {
                navigate('/school-dashboard/my-modules/student/' + idStudent);
            }, disabled: true }),
        React.createElement(ModuleDescription, { keyWords: keywords, loading: loading, module: moduleData }),
        React.createElement("div", { className: Styles.progressBarContent, style: {
                alignItems: loading ? 'center' : 'flex-end'
            } }, loading ? (React.createElement("div", { style: { width: '95%', height: '50px', margin: 'auto' } },
            React.createElement(Skeleton, { width: '100%', height: 50 }))) : (React.createElement(ProgressBar, { backgroundColor: "green", percentage: studentProgressInModulePercent }))),
        React.createElement(Lesson, { module: {
                moduleTitle: moduleData === null || moduleData === void 0 ? void 0 : moduleData.name,
                title: 'Pre Quiz',
                score: 0,
                completed: (prequizUser === null || prequizUser === void 0 ? void 0 : prequizUser.percentResult) > -1,
                progress: (prequizUser === null || prequizUser === void 0 ? void 0 : prequizUser.percentResult) > -1 ? 100 : 0
            }, logo: BulbIcon, onClick: () => {
                var _a, _b;
                return ((_a = prequizUser === null || prequizUser === void 0 ? void 0 : prequizUser.preQuizzes) === null || _a === void 0 ? void 0 : _a.id)
                    ? navigate(`/school-dashboard/take-pre-quiz/${id}/module/${idModule}/pre-quiz/${(_b = prequizUser === null || prequizUser === void 0 ? void 0 : prequizUser.preQuizzes) === null || _b === void 0 ? void 0 : _b.id}?fromMymodules=true`)
                    : '';
            } }),
        isTrial ? (React.createElement("div", { className: Styles.trial },
            React.createElement("p", null, "You are currently on a trial subscription. You can only access the first lesson."))) : (React.createElement("div", { className: Styles.divider })),
        loading ? (React.createElement("div", { style: {
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            } },
            React.createElement(CircleLoader, null))) : (React.createElement(LessonsGrid, { isTrial: isTrial, loading: loading, module: moduleData, lessons: lessons, allLocked: !(prequizUser === null || prequizUser === void 0 ? void 0 : prequizUser.id), idStudent: idStudent }))));
};
export default ModuleDetailStudent;
